export const EventTypes = {
  SCROLL_TOP: 'scroll_top',
  PROCESSING_RESULT: 'deposit-withdraw_result',
  CASHIER_HEIGHT_CHANGE: 'cashier_height_change',
  TRANSACTION_FAILED: 'transactionFailed',
  TRANSACTION_CANCELED: 'transactionCanceled',
  GET_BACK_TO_PAYMENT_METHODS: 'getBackToPaymentMethods',
  CUSTOMER_BALANCE: 'customerBalance',
  SUBMIT_FORM: 'submitForm',
  SUBMIT_PROVIDER_FORM: 'submitProviderForm',
  PAYMENT_INITIATED: 'payment_initiated',
  DEPOSIT_ERROR: 'deposit_error',
  WITHDRAW_ERROR: 'withdraw_error',
  ON_FIELD_FOCUSED: 'on_field_focused',
  ON_AMOUNT_CHOSEN: 'on_amount_chosen',
  ON_VALIDATION_FAILED: 'on_validation_failed',

  ON_PAYMENT_FORM_READY: 'onPaymentFormReady',
  ON_PAYMENT_ATTRIBUTES_CHANGED: 'onPaymentAttributesChanged',
  ON_PAYMENT_DATA_SUBMITTED: 'onPaymentDataSubmitted',
  ON_PAYMENT_DATA_SUBMIT_DECLINED: 'onPaymentDataSubmitDeclined',
  ON_PAYMENT_DATA_PRE_PROCESSED: 'onPaymentDataPreProcessed',
  ON_PAYMENT_DATA_CONFIRMATION_INITIATED: 'onPaymentDataConfirmationInitiated',
  ON_PAYMENT_CONFIRMED: 'onPaymentConfirmed',
  ON_PAYMENT_PROCESSED: 'onPaymentProcessed',
  ON_PAYMENT_PROCESSING_STARTED: 'onPaymentProcessingStarted',
  ON_BONUS_SELECTED: 'onBonusSelected',
  NEW_PAYMENT_INITIATED: 'newPaymentInitiated',
  PAYMENT_RETRIED: 'paymentRetried',

  MESSAGE_TO_LEADER_IFRAME: 'messageToLeaderIframe',

  CHANGE_PAYMENT_METHOD: 'changePaymentMethod',
  ON_CASHIER_CLOSED: 'onCashierClosed',
  ON_BONUS_CALCULATED: 'onBonusCalculated',
  SHOW_MESSAGE: 'showMessage',
} as const;

export type EventType = (typeof EventTypes)[keyof typeof EventTypes];

export interface Event<TPayload = any> {
  type: EventType;
  payload?: TPayload;
}
